import apiClient from './apiClient';

export interface Country {
  id: number;
  name: string;
  code: string;
  phonePrefix: string;
  isActive: boolean;
  currency: string;
  flag?: string;
}

export const countryService = {
  getAll: () => 
    apiClient.get('/v1/countries/all'),

  getAllActive: () =>
    apiClient.get('/countries/active'),

  create: (country: Omit<Country, 'id'>) =>
    apiClient.post('/countries', country),

  update: (id: number) =>
    apiClient.put(`/v1/countries/toggle-selected/${id}`),

  delete: (id: number) =>
    apiClient.delete(`/countries/${id}`),
};